export const TAGS: {
  [key in TagType]: {
    id: TagType
    title: string
    color: string
  }
} = {
  rework: {
    id: 'rework',
    title: 'Rework',
    color: 'magenta'
  },
  urgent: {
    id: 'urgent',
    title: 'Urgent',
    color: 'orange'
  },
  pilot: {
    id: 'pilot',
    title: 'Pilot',
    color: 'green'
  },
  client_rework: {
    id: 'client_rework',
    title: 'Client Rework',
    color: 'purple'
  },
  editor_rework: {
    id: 'editor_rework',
    title: 'Editor Rework',
    color: 'magenta'
  },
  for_review: {
    id: 'for_review',
    title: 'For Review',
    color: 'blue'
  },
  unclaimed: {
    id: 'unclaimed',
    title: 'Unclaimed',
    color: 'yellow'
  },
  ai: {
    id: 'ai',
    title: 'AI',
    color: 'blue'
  }
}
